import { render, staticRenderFns } from "./BtnMsgReprovacao.vue?vue&type=template&id=8f0158d2"
import script from "./BtnMsgReprovacao.vue?vue&type=script&lang=js"
export * from "./BtnMsgReprovacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports